import React from 'react';

import {
  forwardRef,
  Select as ChakraSelect,
  SelectProps as ChakraSelectProps,
} from '@chakra-ui/react';

import { useFormControlGroup } from '../../hooks/use-form-control-group';

export type SelectProps = ChakraSelectProps & {
  ignoreContext?: boolean;
};

const Select = forwardRef<SelectProps, 'select'>(
  ({ ignoreContext, ...restOfSelectProps }: SelectProps, ref) => {
    const { contextData } = useFormControlGroup();

    const selectProps = {
      ...restOfSelectProps,
      ...(ignoreContext
        ? {}
        : (contextData?.components?.Select as SelectProps) || {}),
    };
    return <ChakraSelect ref={ref} {...selectProps} />;
  }
);

export { Select };
